import { useCallback } from "react";
import { useTranslation } from "react-i18next";

/**
 * Multi-select pills are hidden app-wide (filter-style controls render their
 * own chip summaries below the input), so the placeholder carries the
 * selection state instead: "Selected (N)" while values are picked, the given
 * empty-state text otherwise.
 */
export function useMultiSelectCountPlaceholder() {
  const { t } = useTranslation("common");
  return useCallback(
    (count: number, empty?: string): string | undefined =>
      count > 0 ? t("multiSelect.selectedCount", { total: count }) : empty,
    [t],
  );
}
